import { Link } from 'react-router-dom';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="border-b border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity cursor-pointer">
            <i className="ri-arrow-left-line text-2xl text-red-500 w-6 h-6 flex items-center justify-center"></i>
            <span className="text-white font-bold text-lg tracking-wider">BACK TO HOME</span>
          </Link>
          
          <img 
            src="https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/053272dcaa033b9b5356f9612e504e77.png"
            alt="E.T.C Logo"
            className="h-12 w-auto"
          />
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-12 md:py-20">
        <h1 className="text-5xl md:text-6xl font-black text-white mb-6 uppercase tracking-tight">
          Terms of Service
        </h1>
        
        <p className="text-gray-400 text-sm mb-12">
          Last Updated: January 2025
        </p>

        <div className="space-y-8 text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">1. Acceptance of Terms</h2>
            <p>
              By accessing and using ericmoore.online (the "Website"), you accept and agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the Website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">2. Use of the Website</h2>
            <p className="mb-4">You agree to use the Website only for lawful purposes and in accordance with these Terms. You agree not to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Use the Website in any way that violates any applicable federal, state, local, or international law</li>
              <li>Engage in any conduct that restricts or inhibits anyone's use or enjoyment of the Website</li>
              <li>Attempt to gain unauthorized access to any portion of the Website or any systems or networks</li>
              <li>Use any automated system to access the Website in a manner that sends more requests than a human can reasonably produce</li>
              <li>Transmit any viruses, malware, or other malicious code</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">3. Giveaway Rules</h2>
            <p className="mb-4">When participating in giveaways on our Website:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong className="text-white">Eligibility:</strong> Giveaways are open to legal residents of the United States who are 18 years of age or older at the time of entry.</li>
              <li><strong className="text-white">No Purchase Necessary:</strong> No purchase is necessary to enter or win. A purchase will not increase your chances of winning.</li>
              <li><strong className="text-white">Winner Responsibilities:</strong> Winners are responsible for all applicable taxes, fees, and any expenses not explicitly stated as included in the prize (such as flights, vacation stay taxes, and fees).</li>
              <li><strong className="text-white">Prize Fulfillment:</strong> Prizes will be awarded as described in the specific giveaway rules. We reserve the right to substitute prizes of equal or greater value.</li>
              <li><strong className="text-white">Winner Selection:</strong> Winners will be selected randomly and notified via the contact information provided during entry.</li>
              <li><strong className="text-white">Disqualification:</strong> We reserve the right to disqualify any entry that violates these Terms or the specific giveaway rules.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">4. Intellectual Property Rights</h2>
            <p>
              The Website and its entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, audio, and the design, selection, and arrangement thereof) are owned by E.T.C., its licensors, or other providers of such material and are protected by United States and international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
            <p className="mt-4">
              You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our Website without our prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">5. User Content</h2>
            <p>
              If you submit any content to the Website (such as comments, feedback, or giveaway entries), you grant us a non-exclusive, worldwide, royalty-free, perpetual, irrevocable license to use, reproduce, modify, adapt, publish, translate, distribute, and display such content in any media.
            </p>
            <p className="mt-4">
              You represent and warrant that you own or control all rights to the content you submit and that such content does not violate these Terms or any applicable laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">6. Disclaimer of Warranties</h2>
            <p>
              THE WEBSITE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE WEBSITE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE, OR THAT ANY DEFECTS WILL BE CORRECTED.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">7. Limitation of Liability</h2>
            <p>
              TO THE FULLEST EXTENT PERMITTED BY LAW, E.T.C. SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES RESULTING FROM YOUR USE OF THE WEBSITE.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">8. Indemnification</h2>
            <p>
              You agree to defend, indemnify, and hold harmless E.T.C. and its officers, directors, employees, and agents from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms or your use of the Website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">9. Third-Party Services</h2>
            <p>
              The Website may contain links to third-party websites or services (such as KingSumo for giveaway management) that are not owned or controlled by E.T.C. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party websites or services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">10. Modifications to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the new Terms on this page with an updated "Last Updated" date. Your continued use of the Website after any such changes constitutes your acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">11. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the State of Illinois, United States, without regard to its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">12. Termination</h2>
            <p>
              We may terminate or suspend your access to the Website immediately, without prior notice or liability, for any reason, including if you breach these Terms. Upon termination, your right to use the Website will immediately cease.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide">13. Contact Information</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="mt-4">
              <strong className="text-white">Email:</strong> <a href="mailto:etc333music@gmail.com" className="text-red-500 hover:text-red-400 transition-colors cursor-pointer">etc333music@gmail.com</a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-zinc-900 mt-20">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 E.T.C. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="text-gray-500 hover:text-red-500 transition-colors text-sm cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-gray-500 hover:text-red-500 transition-colors text-sm cursor-pointer">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
